import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import HomeIcon from 'icons/Home.icon';
import { useTranslation } from 'react-i18next';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { DATA_ROOM_ROOT_FOLDER } from 'data/global';

import './FolderPath.styles.scss';
import './FolderPath.styles.responsive.scss';

const SEPARATOR = '...';
const MAX_LENGTH = 2;

const SEPARATOR_NODE = { _id: 'separator-id', name: SEPARATOR };

type FolderPathProps = {
  className?: string;
  basePath: string;
  maxLength?: number;
  showIndex?: boolean;
  route: DataRoomNode[];
  onRouteClick?: (node: DataRoomNode) => void;
};

const FolderPath: React.FC<FolderPathProps> = (props) => {
  const {
    className,
    route,
    basePath,
    showIndex,
    maxLength = MAX_LENGTH,
    onRouteClick,
  } = props;

  const classes = classNames('folder-path', className);

  const { t } = useTranslation();

  const routeNodes = useMemo(() => {
    const pathToShow = route.slice(-maxLength);

    return [
      ...(route.length > maxLength ? [SEPARATOR_NODE] : []),
      ...pathToShow,
    ] as DataRoomNode[];
  }, [route, maxLength]);

  return (
    <nav className={classes}>
      <Link to={basePath} onClick={() => onRouteClick?.(null)}>
        <HomeIcon />
        {t(DATA_ROOM_ROOT_FOLDER)}
      </Link>
      {routeNodes.map((node) => {
        const { _id, name, docIndex, hasInvalidDocIndex } = node;

        return name !== SEPARATOR ? (
          <Link
            key={_id}
            to={`${basePath}${_id}`}
            {...(name !== SEPARATOR && {
              onClick: () => onRouteClick?.(node),
            })}
          >
            <p>
              {showIndex && docIndex && !hasInvalidDocIndex
                ? `${docIndex} ${name}`
                : name}
            </p>
          </Link>
        ) : (
          <span key={_id}>{SEPARATOR}</span>
        );
      })}
    </nav>
  );
};

export default FolderPath;
